import React from 'react'
import { Box, keyframes } from '@chakra-ui/react'

interface LoadingBubblesProps {
  height?: number | string
}

const float = keyframes`
  0% {
    transform: translateY(0) scale(0.3);
    opacity: 0;
  }
  5% {
    opacity: 0.8;
  }
  30% {
    transform: translateY(-200px) scale(0.5);
  }
  50% {
    transform: translateY(-400px) scale(0.8);
  }
  70% {
    transform: translateY(-600px) scale(1);
  }
  95% {
    opacity: 0.8;
  }
  100% {
    transform: translateY(-800px) scale(0.3);
    opacity: 0;
  }
`

const LoadingBubbles = ({ height = 400 }: LoadingBubblesProps) => {
  // Pre-calculate random values to prevent recalculation on re-render
  const bubbleProps = React.useMemo(() => {
    return Array.from({ length: 15 }).map(() => ({
      duration: Math.random() * 4 + 8,
      delay: Math.random() * 5,
      size: Math.random() * 30 + 15,
      left: Math.random() * 80 + 10
    }))
  }, [])

  // Generate bubbles with consistent properties
  const bubbles = bubbleProps.map((props, i) => {
    return (
      <Box
        key={i}
        position="absolute"
        bottom="0"
        left={`${props.left}%`}
        width={`${props.size}px`}
        height={`${props.size}px`}
        borderRadius="full"
        bgGradient="radial(circle at 25% 25%, orange.300, purple.500)"
        sx={{
          animation: `${float} ${props.duration}s linear infinite`,
          animationDelay: `${props.delay}s`,
          backdropFilter: 'blur(2px)',
          background: 'radial-gradient(circle at 25% 25%, rgba(255, 165, 0, 0.4), rgba(128, 0, 255, 0.2))',
          boxShadow: '0 0 10px rgba(255, 165, 0, 0.3)',
          willChange: 'transform',
          transform: 'translate3d(0, 0, 0)'
        }}
      />
    )
  })

  return (
    <Box
      position="relative"
      height={height}
      width="100%"
      overflow="hidden"
      bg="transparent"
      sx={{
        perspective: '1000px',
        WebkitPerspective: '1000px',
        '& > div': {
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden'
        }
      }}
    >
      {bubbles}
    </Box>
  )
}

export default LoadingBubbles
